<template>
  <v-layout justify-left row wrap>
    <v-flex xs12>
      <v-tabs fixed-tabs show-arrows dark color="grey lighten-1">
        <v-tab v-for="(topic, key) in topics" :key="key" ripple :to="topic.to">
          <div><v-icon small :class="['fas', topic.icon]"></v-icon><span class="hidden-xs-only">&nbsp;&nbsp;{{ topic.title }}</span></div>
        </v-tab>
      </v-tabs>
      <v-parallax src="static/bigstock--173332025.jpg" height="300">
        <h2>Business Development / Sales</h2>
      </v-parallax>
      <div class="cta-block">Let us customize <router-link to="/contact">a solution for you</router-link></div>
      <v-card>
        <v-container fluid>
          <v-layout row wrap>
            <h3 class="sub-header">Developing Productive Customer Relationships</h3>
            <p>During this course participants will learn about behavioral styles, and how to create productive relationships with their customers by making them more comfortable.  The learner will have the opportunity to experience a DiSC assessment and learn about their own style, and how their style works for them or against them in business development.   They will also learn to read the styles of their customers, and to implement strategies to effectively sell to all styles of customers.</p>
            <h3 class="sub-header">Developing a Consultative Approach to Business Development</h3>
            <p>The best business developers are those that build long term relationships with their customers, and help their customers solve significant problems or achieve meaningful goals.  This course teaches a structured approach to business development.  From researching the customer’s business or industry, to planning the sales interaction with purpose and engaging questions, to laying out a compelling value proposition and asking for commitment, the process is all encompassing.  Participants will be engaged in relevant and robust skills practice to boost both their confidence and their competence.</p>
            <h3 class="sub-header">Being an Effective Business Development Coach</h3>
            <p>During this course, participants will learn how to diagnose business development performance issues and what to do about them.  They will also learn how to engage with their coachees to help them plan and/or execute their business development calls.  Coaches will learn to create accountability for their coachees, and how to develop meaningful goals and get buy-in.</p>
            <h3 class="sub-header">Strategic Account Management</h3>
            <p>The Pareto Principle says that 80% of our business comes from 20% of our customers.  Therefore, we better tune in and figure out how to create real value for these customers.  This course helps participants to methodically identify their strategic accounts, and teaches them how to create an account plan.  The learner will be engaged in researching their accounts, SWOT analysis, goal setting with action steps and a contact plan.  Whether the goal is to more effectively prospect for new customers, or whether it is to maximize sales with existing customers, this course will bring valuable skills and processes to the learner.</p>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'business',
  data () {
    return {
      topics: [
        {
          title: 'Business Development / Sales',
          icon: 'fa-university',
          excerpt: 'Offering courses that teach your staff to become better business builders through stronger customer relationships, better performance evaluation and bonded team dynamics.',
          to: '/topics/business'
        },
        {
          title: 'Leadership Develop',
          icon: 'fa-hand-point-right',
          excerpt: 'Learn the difference between being a manager and being a leader, and how to talk to people at all levels of the organization in ways that engage and strengthen.',
          to: '/topics/leadership'
        },
        {
          title: 'Team Develop',
          icon: 'fa-users',
          excerpt: 'Organizations need to learn how to build cohesive teams if they expect to build a sustainable business enterprise by guaging the members.',
          to: '/topics/team'
        },
        {
          title: 'Management Develop',
          icon: 'fa-user-tie',
          excerpt: 'Each manager is as individual in style as they are in personality. Each manager can develop those individual traits to their best advantage.',
          to: '/topics/management'
        }
      ]
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/topics/Business.vue